import React from "react";
import { QueryRenderer, ReadyState } from "react-relay";
import { Match } from "found";

import { IViewer, IOrg, SortDirection, SortType, ActivityFilter } from "@schema";

import { adminPanelBillingGroupsMembersQuery } from "./AdminPanelBillingGroupsMembers.gql";

import { Loader } from "@clockwise/web-commons/src/components/loader";

import { handleReadyStateError } from "@util/relay.util";
import { getCurrentEnvironment } from "@src/state/relay-environment";

import { AdminPanelBillingGroupsMembers } from "./AdminPanelBillingGroupsMembers";
import { MAX_MEMBERS_DISPLAYED } from "./AdminPanelBillingGroupsMembers.constants";

// import { paths } from "@clockwise/client-commons/src/constants/site";

export interface IAdminPanelBillingGroupsMembersContainerProps {
  orgRelayId: string;
  match: Match;
  primaryBillingGroupId?: string;
}

export const AdminPanelBillingGroupsMembersContainer = (
  rendererProps: IAdminPanelBillingGroupsMembersContainerProps,
) => {
  let cachedViewer: IViewer;
  let cachedOrg: IOrg;
  const environment = getCurrentEnvironment();

  const billingGroupId =
    rendererProps.match.params["billingGroupId"] ||
    rendererProps.primaryBillingGroupId ||
    undefined;
  // window.history.pushState("", "", paths.admin);

  return (
    <QueryRenderer
      environment={environment}
      query={adminPanelBillingGroupsMembersQuery}
      variables={{
        orgRelayId: rendererProps.orgRelayId,
        sortType: SortType.FullName,
        sortDirection: SortDirection.Ascending,
        searchQuery: null,
        activityFilter: !!billingGroupId
          ? ActivityFilter.CurrentUser
          : ActivityFilter.CurrentUserOrInvited,
        limit: MAX_MEMBERS_DISPLAYED,
        billingGroupId,
      }}
      render={(readyState: ReadyState) => {
        const { error, props } = readyState;
        if (error) {
          handleReadyStateError(error, "AdminPanelBillingGroupsMembers");
          return null;
        }

        const org = (props && props.org) || null;
        const viewer = (props && props.viewer) || null;

        if (viewer) {
          cachedViewer = viewer;
        }

        if (org) {
          cachedOrg = org;
        }

        if (!cachedOrg || !cachedViewer) {
          return <Loader />;
        }

        return (
          <AdminPanelBillingGroupsMembers
            viewer={viewer}
            org={org}
            billingGroupId={billingGroupId}
          />
        );
      }}
    />
  );
};
